import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-users-sync-config-skeleton',
  templateUrl: './users-sync-config-skeleton.component.html',
  styleUrls: ['./users-sync-config-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class UsersSyncConfigSkeletonComponent {}